<template>
    <v-app id="login">
        <v-container fluid fill-height class="background">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4" lg="4">
                    <!-- Logo Section -->
                    <div class="text-center mb-10">
                        <img src="/static/v-logo-login.png" alt="nhapkhaunamtrung.com Admin" class="logo-container">
                    </div>

                    <!-- Login Card -->
                    <v-card class="login-panel mx-auto pa-6" max-width="400" elevation="12" rounded="lg">
                        <v-card-title class="justify-center text-h5 font-weight-bold primary--text mb-4">
                            Đăng Nhập
                        </v-card-title>

                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field v-model="model.username" label="Tên đăng nhập"
                                    prepend-inner-icon="fa-user" outlined dense
                                    :rules="[v => !!v || 'Vui lòng nhập tên đăng nhập']" @keyup.enter="login"
                                    class="rounded-lg"></v-text-field>

                                <v-text-field v-model="model.password" label="Mật khẩu" prepend-inner-icon="fa-lock"
                                    :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword" outlined dense
                                    :rules="[v => !!v || 'Vui lòng nhập mật khẩu']" @keyup.enter="login"
                                    class="rounded-lg"></v-text-field>
                            </v-form>
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn color="#0088cc" @click="login" :loading="loading" large depressed
                                class="white--text px-8" :disabled="!valid" rounded>
                                Đăng Nhập
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Snackbar -->
            <v-snackbar v-model="snackbar" :timeout="6000" top rounded="pill" elevation="24" color="error">
                {{ message }}
                <template v-slot:action="{ attrs }">
                    <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                        Đóng
                    </v-btn>
                </template>
            </v-snackbar>
        </v-container>
    </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            token: state => state.authentication.token,
            resData: state => state.authentication.resData,
        }),
    },
    data: () => ({
        valid: true,
        loading: false,
        model: {
            username: '',
            password: ''
        },
        showPassword: false,
        snackbar: false,
        message: ''
    }),
    watch: {
        resData() {
            if (this.resData && this.resData.status_code == 400) {
                this.snackbar = true;
                this.message = 'Tài khoản hoặc mật khẩu không đúng.'
            } else if (this.token && this.token !== '') {
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            }
            this.loading = false;
        }
    },
    methods: {
        login() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.model.FirebaseToken = localStorage.getItem('FCM_Token')
                this.$store.dispatch('authentication/login', this.model);
            }
        }
    }
};
</script>

<style lang="css" scoped>
.background {
    /* background: linear-gradient(135deg, #747474, #000913); */ /* Removed gradient */
    position: relative; /* Added for pseudo-element positioning */
    min-height: 100vh;
    overflow: hidden; /* Ensures blurred edges of pseudo-element don't spill */
}

.background::before { /* Added new rule for blurred background image */
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/static/bg-image.jpg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    filter: blur(5px); /* Adjust blur radius as needed, e.g., blur(3px), blur(8px) */
    z-index: -1; /* Place it behind the container's content */
}

.login-panel {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
}

.logo-container {
    width: 280px;
    padding: 10px;
}

.v-btn {
    text-transform: none;
    font-weight: 500;
    letter-spacing: 1px;
}

#login {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}
</style>